import { getLegacyEnvVariable } from '@/app/components/LegacyEnvVariables/util';

require('isomorphic-fetch');

export const getGraphQlEndpoint = () => {
  const base = getLegacyEnvVariable('NEXT_PUBLIC_ECOM_API_ENDPOINT');
  return base ? `${base}/graphql` : undefined;
};
